import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';




import { ChatPanelModule } from 'app/layout/components/chat-panel/chat-panel.module';


import { NavbarModule } from 'app/layout/components/navbar/navbar.module';


import { VerticalLayout2Component } from 'app/layout/vertical/layout-2/layout-2.component';

@NgModule({
    imports: [
    RouterModule,
    ChatPanelModule,
    NavbarModule,
    VerticalLayout2Component,
],
    exports: [
        VerticalLayout2Component
    ]
})
export class VerticalLayout2Module
{
}
